import { defineMessages } from 'react-intl';

export default defineMessages({
	seekBarLabel: {
		id: 'app.contentPlayer.seekBarLabel',
		defaultMessage: 'Seek slider',
		description: 'The slider input used to control the timeline of an audio or video playback',
	},
});
